export default __webpack_public_path__ + "static/media/dislikee.c3832ed4.svg";